import React from 'react';
import IssuerListContainer from '@/creditflowresearch/ui/components/trace/common/Sidebar/Sections/IssuerListContainer';
import OneLevelListContainer from '@/creditflowresearch/ui/components/trace/common/Sidebar/Sections/OneLevelListContainer';
import RangeContainer from '@/creditflowresearch/ui/components/trace/common/Sidebar/Sections/RangeContainer';
import TwoLevelListContainer from '@/creditflowresearch/ui/components/trace/common/Sidebar/Sections/TwoLevelListContainer';
import TimePeriodContainer from '@/creditflowresearch/ui/components/trace/common/Sidebar/Sections/TimePeriodContainer';
import Sections from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/Sections';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import MaturityDateContainer from '@/creditflowresearch/ui/components/trace/common/Sidebar/Sections/MaturityDateContainer';
import OneListByMapContainer from '@/creditflowresearch/ui/components/trace/common/Sidebar/Sections/OneListByMapContainer';
import { RemunerationsListMap, TradeCPTsFilterMap } from '@/creditflowresearch/ui/components/trace/contants';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';

const getFiltersTitleMapping = (timeZoneAbbr: string) => ({
  tradeTime: `Trade Time (${ timeZoneAbbr })`,
  sectorList: 'Sectors & Subsectors',
  issuerList: 'Issuers',
  size: 'Trade Size',
  price: 'Trade Price ($)',
  coupon: 'Coupon (%)',
  maturityDate: 'Maturity Date',
  contraPartyTypeList: 'Contra Party Type',
  remunerationList: 'Remuneration',
  reportingPartyTypeList: 'Reporting Party Type',
  reportingPartySideList: 'Side',
  tradeStatusList: 'Status',
});

const filtersComponentsMapping = {
  tradeTime: {
    component: TimePeriodContainer,
    componentProps: {
      filterName: 'tradeTime',
      step: 0.01,
      decimals: 2,
    },
  },
  sectorList: {
    component: TwoLevelListContainer,
    componentProps: {
      filterName: 'includedSubsectorIds',
      parentKeyPrefix: 'sector',
    },
  },
  issuerList: {
    component: IssuerListContainer,
    componentProps: {
      filterName: 'includedIssuerIds',
    },
  },
  size: {
    component: RangeContainer,
    componentProps: {
      filterName: 'size',
      step: 0.01,
      decimals: 2,
    },
  },
  price: {
    component: RangeContainer,
    componentProps: {
      filterName: 'price',
      step: 0.01,
      decimals: 2,
    },
  },
  coupon: {
    component: RangeContainer,
    componentProps: {
      filterName: 'coupon',
      step: 0.01,
      decimals: 2,
    },
  },
  maturityDate: {
    component: MaturityDateContainer,
    componentProps: {
      filterName: 'maturityDate',
      step: 1,
    },
  },
  contraPartyTypeList: {
    component: (props) => <OneListByMapContainer { ...props } map={ TradeCPTsFilterMap } />,
    componentProps: {
      filterName: 'includedContraPartyTypes',
    },
  },
  remunerationList: {
    component: (props) => <OneListByMapContainer { ...props } map={ RemunerationsListMap } />,
    componentProps: {
      filterName: 'includedRemunerations',
    },
  },
  reportingPartyTypeList: {
    component: OneLevelListContainer,
    componentProps: {
      filterName: 'includedReportingPartyTypes',
    },
  },
  reportingPartySideList: {
    component: OneLevelListContainer,
    componentProps: {
      filterName: 'includedReportingPartySides',
    },
  },
  tradeStatusList: {
    component: OneLevelListContainer,
    componentProps: {
      filterName: 'includedTradeStatuses',
    },
  },
};

const SectionsContainer = (props) => {
  const { timeZone } = useUserTimeZoneContext();
  const { isFetching, itemsFilter } = useTraceFiltersContext();

  return (
    <Sections
      { ...props }
      isFetching={ isFetching }
      items={ itemsFilter }
      filtersComponentsMapping={ filtersComponentsMapping }
      filtersTitleMapping={ getFiltersTitleMapping(timeZone.abbr) }
    />
  );
};

export default SectionsContainer;
